import React from 'react';

export default function CustomIconSquareMinus(
  props: React.SVGProps<SVGSVGElement>,
) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='transparent'
      stroke='currentColor'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
      className='tabler-icon tabler-icon-square-minus'
      fontSize='medium'
      {...props}
    >
      <path d='M3 3m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v14a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2z'></path>
      <path d='M9 12h6'></path>
    </svg>
  );
}
